<kendo-listview
  [data]="documents"
  containerClass="k-d-flex k-flex-col k-flex-nowrap overflow-auto"
>
  <ng-template
    kendoListViewItemTemplate
    let-document="dataItem"
    let-isFirst="isFirst"
  >
    <circ-document-card
      class="dataItem"
      [document]="document"
      (documentDelete)="onDeleteDocument(document.doc)"
      (documentDownload)="onDownloadDocument(document.doc)"
      (documentOpen)="onOpenDocument(document.doc)"
    ></circ-document-card>
  </ng-template>
</kendo-listview>
